module.exports = __webpack_public_path__ + "img/exit-fullscreen-icon.483e85f4.svg";